module.exports = __webpack_public_path__ + "static/media/1.515d05e4.png";